import { render, staticRenderFns } from "./SelectMultipleOrgans.vue?vue&type=template&id=4649107d"
import script from "./SelectMultipleOrgans.vue?vue&type=script&lang=js"
export * from "./SelectMultipleOrgans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports